import React from 'react';
import { oneOf, string, func } from 'prop-types';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Message as MessageUI } from 'semantic-ui-react';

import { cap } from '~/utils';

const poseDelay = 300;
const poseConfig = {
    hidden: {
        y: 10,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
    },
};

// Animated wrapper
const PosedContainer = styled(motion.div)`
  margin: 1rem;
  ${poseConfig};
`;

class Message extends React.Component {
    static propTypes = {
        id: string.isRequired,
        type: oneOf(['info', 'success', 'warning', 'error']).isRequired,
        header: string.isRequired,
        content: string,
        handleRemoveMessage: func.isRequired,
    };

    static defaultProps = {
        content: null,
    };

    constructor(props) {
        super(props);

        this.state = {
            pose: 'hidden',
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ pose: 'visible' });
        }, poseDelay);
        this.autoClear();
    }

    getSeverityProps = () => {
        const { type } = this.props;
        switch (type) {
            case 'success':
                return { [type]: true, icon: 'check' };
            case 'warning':
                return { [type]: true, icon: 'warning sign' };
            case 'error':
                return { [type]: true, icon: 'attention' };
            default:
                return { info: true, icon: 'info circle' };
        }
    };

    getDismissTimeout = () => {
        const { type } = this.props;
        switch (type) {
            case 'success':
                return 5000;
            case 'warning':
                return 8000;
            case 'error':
                return null;
            default:
                return 3000;
        }
    };

    handleDismiss = () => {
        const { id, handleRemoveMessage } = this.props;
        this.setState({ pose: 'hidden' }, () => {
            setTimeout(() => {
                handleRemoveMessage(id);
            }, poseDelay);
        });
    };

    autoClear = () => {
        const timeout = this.getDismissTimeout();
        if (!timeout) {
            return;
        }
        setTimeout(() => {
            this.handleDismiss();
        }, timeout);
    };

    render = () => {
        const { header, content } = this.props;
        const { pose } = this.state;

        return (
            <PosedContainer initial="hidden" animate={pose}>
                <MessageUI
                    size="small"
                    header={cap(header)}
                    content={cap(content)}
                    onDismiss={this.handleDismiss}
                    {...this.getSeverityProps()}
                />
            </PosedContainer>
        );
    };
}

export default Message;
